module.exports = new __parcel__URL__("crossIcon.47cea1b8.svg").toString();